import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect, Component } from 'react';
import { Formik, Form, Field, ErrorMessage, withFormik } from 'formik';
import * as yup from 'yup';
import { Row, Col } from 'react-bootstrap';
import { Link } from '@sitecore-jss/sitecore-jss-react'; //ga tracker

import gaTracker from '../../../util/ga-analytics/gaTracker';
import { FormCheckbox, FormInput } from '../elements'; // Global Element

export default (function (props) {
  var changeHandler = props.changeHandler,
      setFieldValue = props.setFieldValue,
      firstName = props.firstName,
      lastName = props.lastName,
      phoneNumber = props.phoneNumber,
      emailAddress = props.emailAddress,
      zipCode = props.zipCode,
      newsletter = props.newsletter,
      _props$terms = props.terms,
      terms = _props$terms === void 0 ? {} : _props$terms,
      _props$privacy = props.privacy,
      privacy = _props$privacy === void 0 ? {} : _props$privacy,
      values = props.values;

  var _useState = useState(values.newsletter),
      _useState2 = _slicedToArray(_useState, 2),
      hiddenField = _useState2[0],
      setHiddenField = _useState2[1];

  var checkBoxClick = function checkBoxClick(event) {
    var target = event.target;
    var data = {
      target: {
        name: event.target.name,
        value: event.target.checked
      }
    };
    changeHandler(data); // const data = {
    //   gtm: {
    //     uniqueEventId: id,
    //     elementTarget:target.name=== 'zipCode' ? target.value : '',
    //     zipcode: target.name=== 'zipCode' ? target.value : '',
    //     elementId: htmlId
    //   },
    //   event: 'gtm.click'
    // }
    // gaTracker(data);
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: "6"
  }, /*#__PURE__*/React.createElement(Field, {
    value: values.firstName,
    name: "firstName",
    label: "First Name",
    component: FormInput,
    className: "cb-form__input--full",
    changeFullHandler: changeHandler
  })), /*#__PURE__*/React.createElement(Col, {
    sm: "6"
  }, /*#__PURE__*/React.createElement(Field, {
    value: values.lastName,
    name: "lastName",
    label: "Last Name",
    component: FormInput,
    className: "cb-form__input--full",
    changeFullHandler: changeHandler
  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Field, {
    value: values.phoneNumber,
    type: "tel",
    name: "phoneNumber",
    label: "Phone Number",
    component: FormInput,
    className: "cb-form__input--full",
    changeFullHandler: changeHandler
  }))), hiddenField && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Field, {
    value: values.emailAddress,
    type: "email",
    name: "emailAddress",
    label: "Email Address",
    component: FormInput,
    className: "cb-form__input--full",
    changeFullHandler: changeHandler
  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    lg: "6"
  }, /*#__PURE__*/React.createElement(Field, {
    value: values.zipCode,
    name: "zipCode",
    label: "Zip Code",
    id: "waitlist-zipcode",
    component: FormInput,
    className: "cb-form__input--full",
    changeFullHandler: changeHandler
  })))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    className: "cb-form__removebm"
  }, /*#__PURE__*/React.createElement(CheckboxInput, {
    value: true,
    name: "newsletter",
    id: "waitlist-newsletter",
    label: "Sign up for Cracker Barrel emails.",
    component: CheckboxInput,
    setFieldValue: setFieldValue,
    checked: values.newsletter //  changeFullHandler={checkBoxClick.bind(null, '39', "waitlist-newsletter")}
    ,
    changeFullHandler: function changeFullHandler(e) {
      setHiddenField(e.target.checked);
      return checkBoxClick(e);
    } //.bind(null, '39', "waitlist-newsletter")}}

  }))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("p", {
    className: "cb-form__waitlist--disclaimer"
  }, "By submitting your request, you are agreeing to our ", /*#__PURE__*/React.createElement("a", {
    href: "./legal"
  }, "Terms of Use"), " and ", /*#__PURE__*/React.createElement("a", {
    href: "./privacy"
  }, "Privacy Policy")))));
});

var CheckboxInput = function CheckboxInput(props) {
  var value = props.value,
      changeFullHandler = props.changeFullHandler,
      id = props.id;
  return /*#__PURE__*/React.createElement(Field, _extends({}, props, {
    name: props.name,
    render: function render(_ref) {
      var field = _ref.field;
      return /*#__PURE__*/React.createElement(FormCheckbox, {
        value: value,
        field: field,
        type: "checkbox",
        label: props.label,
        checked: field.value,
        onClick: function onClick() {
          return props.setFieldValue(props.name, !field.value);
        },
        changeFullHandler: changeFullHandler
      });
    }
  }));
};